import {Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {RanglisteService} from "../../services/rangliste.service";
import {first} from "rxjs";
import {League} from "../../../../../../drc-touch/drc-touch/src/app/models/league.model";
import {AppService} from "../../services/app.service";
import {Team} from "../../models/team.model";
import {isPlatformBrowser, NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  standalone: true,
  imports: [
    NgIf,
    NgForOf
  ],
  styleUrls: ['./teams.component.less']
})
export class TeamsComponent implements OnInit {

  @ViewChild('opening') opening!: ElementRef;
  show: boolean = false;

  currentTeams: Team[] = [];

  constructor(private Service: AppService, @Inject(PLATFORM_ID) private platformId: Object) {
  }

  @HostListener('document:scroll')
  onViewportScroll() {
    if (!isPlatformBrowser(this.platformId)) { return; }
    const windowHeight = window.innerHeight;
    const boundingRectFive = this.opening.nativeElement.getBoundingClientRect();

    if (boundingRectFive.top <= windowHeight - 200) {
      this.show = true;
    } else {
      this.show = false;
    }
  }

  ngOnInit(): void {
    this.Service.getTeams().pipe(first()).subscribe({
      next: (data: any) => {
        this.currentTeams = data.data;
      }
    })
  }

  getLeagueType(team: Team) {
    switch (team.type) {
      case 'dsab':
        return 'DSAB';
        break;
      case 'nhdl':
        return 'NHDL';
        break;
      case 'schumacher':
        return 'Schumacher';
        break;
    }

    return '';
  }

  getLeagueName(leagueName: string) {
    if (leagueName.includes('Regional')) leagueName = 'Regio';
    if (leagueName.includes('Bundesliga')) leagueName = 'Bulli';
    return leagueName;
  }

  getNextDate(team: {leagueId: number, seasonId: number, name: string, league: undefined | League[]}) {
    if (!team.league) return '-';
    let homeGames = team.league[0].dates.filter((element) => element.homeTeam === team.name);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (let game of homeGames) {
      const [day, month, year] = game.date.split(".");
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      date.setHours(0, 0, 0, 0);
      if (date >= today) {
        return game.date + `<br>gegen ${game.guestTeam}`;
      }
    }

    return '-';
  }

  getPlace(team: {leagueId: number, seasonId: number, name: string, league: undefined | League[]}) {
    if (!team.league) return '';

    let league = team.league[0];
    let result = league.results.find((element) => element.team === team.name);
    return result?.place.toString()
  }

}
